import React from 'react'
import LogoImage from '../assets/mattilsynet_logo.svg'

const Header = () => {
	return (
		<header>
			<div className='header-restrictor'>
				<img src={LogoImage} alt='Mattilsynet' className='mattilsynet-logo' />
			</div>
		</header>
	)
}

export default Header